<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-bot" class="sidebar__link">
      <ChatBubbleLeftRightIcon class="w-5 h-5" />
      <p>Group bot</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/channel-bot" class="sidebar__link">
      <ChatBubbleLeftRightIcon class="w-5 h-5" />
      <p>Channel bot</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-coins" class="sidebar__link">
      <CurrencyDollarIcon class="w-5 h-5" />
      <p>Coins</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-news" class="sidebar__link">
      <NewspaperIcon class="w-5 h-5" />
      <p>Mars news</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-shop" class="sidebar__link">
      <ShoppingBagIcon class="w-5 h-5" />
      <p>Mars shop</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-survey" class="sidebar__link">
      <QuestionMarkCircleIcon class="w-5 h-5" />
      <p>{{ $t("Sidebar.question-answer") }}</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/marketing-badges" class="sidebar__link">
      <ShieldCheckIcon class="w-5 h-5" />
      <p>Badges</p>
    </router-link>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import {
  ChatBubbleLeftRightIcon,
  CurrencyDollarIcon,
  NewspaperIcon,
  ShoppingBagIcon,
  QuestionMarkCircleIcon,
  ShieldCheckIcon,
} from "@heroicons/vue/24/outline";

const { t } = useI18n();
</script>
